import React from 'react'

export default function ContactsPage () {
  return (
    <div>
      <h1>ContactsPage</h1>
      <p>Telegram: ankaboot</p>
    </div>
  )
}
